import React from 'react';

const results = () => (
  <div>Results</div>
);

export default results;



// WEBPACK FOOTER //
// ./focus_groups/containers/comments.js